<template>
  <v-form ref="groupRegisterForm" @submit.prevent="register">
    <v-text-field
      solo
      v-model="user.email"
      :rules="[rules.required]"
      :label="$t('common.email')"
      prepend-inner-icon="mdi-email"
      disabled
    ></v-text-field>
    <v-text-field
      solo
      v-model="user.name"
      :rules="[rules.required]"
      :label="$t('common.name')"
      prepend-inner-icon="mdi-account"
    ></v-text-field>
    <v-text-field
      solo
      v-model="user.password"
      :rules="[rules.required, rules.passwordMinLength]"
      type="password"
      :label="$t('common.password')"
      prepend-inner-icon="mdi-lock"
    ></v-text-field>
    <v-text-field
      solo
      v-model="user.confirmPassword"
      :rules="[rules.required, rules.equalWithPassword(user.password)]"
      type="password"
      :label="$t('common.confirmPassword')"
      prepend-inner-icon="mdi-lock"
    ></v-text-field>

    <p>
      {{ $t('termsAndConditions.formText') }}
      <router-link target="_blank" :to="'terms-and-conditions'">
        <span>{{ $t('termsAndConditions.title') }} </span>
      </router-link>
      <span> {{ $t('termsAndConditions.and') }} </span>
      <router-link target="_blank" :to="'privacy-policy'">
        <span>{{ $t('privacyPolicy.title') }} </span>
      </router-link>
    </p>

    <v-card-actions class="pa-0">
      <v-btn dark block color="primary" type="submit" :loading="loading">
        {{ $t('auth.signUp') }}
      </v-btn>
    </v-card-actions>
  </v-form>
</template>

<script>
import validators from '../../common/validators';
import { GROUP_REGISTER } from '../../store/auth/types';

const PASSWORD_MIN_LENGTH = 6;

export default {
  name: 'group-register-form',
  props: {
    email: {
      type: String,
      required: true
    },
    token: {
      type: String,
      required: true
    }
  },
  data() {
    return {
      loading: false,
      user: {
        name: '',
        email: '',
        password: '',
        confirmPassword: '',
        grt: ''
      },
      rules: {
        required: validators.required(this.$i18n.t('common.requiredField')),
        passwordMinLength: validators.min(
          PASSWORD_MIN_LENGTH,
          this.$i18n.t('common.minLength', {
            value: PASSWORD_MIN_LENGTH
          })
        ),
        equalWithPassword: prop =>
          validators.equal(prop, this.$i18n.t('common.passwordMismatch'))
      }
    };
  },
  created() {
    this.user.email = this.$route.query.email;
    this.user.grt = this.$route.query.grt;
  },
  methods: {
    async register() {
      if (!this.$refs.groupRegisterForm.validate()) {
        return;
      }

      this.loading = true;

      try {
        const result = await this.$store.dispatch(GROUP_REGISTER, this.user);
        this.$i18n.locale = result.lang;

        this.$router.push({
          path: '/successfully-registration',
          query: {
            email: this.user.email
          }
        });
      } finally {
        this.loading = false;
      }
    }
  }
};
</script>
